import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';
import LoginHeaderOperational from './LoginHeaderOperational';
import Sidebar_Progress from '../layouts/Operational_Sidebar_Progress.component';
import { API_URL } from '../../constant/API_Settings';
import { fetchReportJson, reportNumberFormat, downloadReportPdf, formatReportDate, formatReportDateRange } from '../../utils/reportFormat';
import logo from '../../img/logo.svg';
import {
  OtherReportActionButtons,
  OtherReportFilterCard,
  ReportDateRangeFields,
  OtherReportLoader,
  OtherReportPageHeader,
  OtherReportResultsZone,
  OtherReportShell,
  OtherReportToolbar,
} from './other-reports/OtherReportShared';

const DealerStatementReport = (props) => {
  const [meta, setMeta] = useState({});
  const [inputValues, setInputValues] = useState({});
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);

  useEffect(() => {
    fetchReportJson(`${API_URL}/dealer_statement/meta`)
      .then(setMeta)
      .catch((error) => swal('Dealer Statement', error.message, 'error'));
  }, []);

  const loadReport = async () => {
    if (!inputValues.start_date || !inputValues.end_date) {
      swal('Please select start and end dates', '', 'warning');
      return;
    }

    setLoading(true);
    setReport(null);

    try {
      const data = await fetchReportJson(`${API_URL}/dealer_statement`, {
        from_date: inputValues.start_date,
        to_date: inputValues.end_date,
      });
      setReport(data);
    } catch (error) {
      swal('Dealer Statement', error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const downloadPdf = async () => {
    if (!inputValues.start_date || !inputValues.end_date) {
      swal('Please select start and end dates', '', 'warning');
      return;
    }

    setPdfLoading(true);
    try {
      await downloadReportPdf(
        `${API_URL}/dealer_statement/pdf`,
        {
          from_date: inputValues.start_date,
          to_date: inputValues.end_date,
        },
        'dealer_statement.pdf',
      );
    } catch (error) {
      swal('Dealer Statement', error.message, 'error');
    } finally {
      setPdfLoading(false);
    }
  };

  const openingRows = (report?.opening_bal || []).filter(
    (row) => Number(row.outstanding || 0) !== 0
  );

  return (
    <div className="main-container page-wrap">
      <div className="d-md-flex">
        <Sidebar_Progress props={props} progress={14} operation={4} op={4} />
        <div className="content-area">
          <LoginHeaderOperational props={props} page_title=" " />
          <OtherReportShell>
            <OtherReportPageHeader title="Dealer Statement" badge="Reports" />
            <OtherReportFilterCard>
              <OtherReportToolbar
                actionsWide
                dates={(
                  <>
                    <ReportDateRangeFields
                      startDate={inputValues.start_date}
                      endDate={inputValues.end_date}
                      onChange={({ start_date, end_date }) => setInputValues({
                        ...inputValues,
                        start_date,
                        end_date,
                      })}
                    />
                  </>
                )}
                actions={(
                  <OtherReportActionButtons
                    loading={loading}
                    pdfLoading={pdfLoading}
                    onSubmit={loadReport}
                    onDownloadPdf={downloadPdf}
                  />
                )}
              />
            </OtherReportFilterCard>
            <OtherReportResultsZone>
              {loading && <OtherReportLoader message="Generating dealer statement" />}
              {report && !loading && (
              <div className="form-wrap balace-sheetwrap">
                <div className="row mb-3">
                  <div className="col-md">
                    <h2 className="table-title mb-1">{report.pump_name}</h2>
                    <h4 className="table-title mb-1">{report.dealer_name} statement</h4>
                    <h5>{formatReportDateRange(report.start_date, report.end_date)}</h5>
                    <img src={logo} className="img-fluid float-end" width="100" alt="logo" />
                  </div>
                </div>

                <div className="table-widget mb-4">
                  <table className="table border">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Invoice number</th>
                        <th>Product</th>
                        <th>Particulars</th>
                        <th>Description</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th>Outstanding</th>
                      </tr>
                    </thead>
                    <tbody>
                      {openingRows.map((row, index) => (
                        <tr key={`opening-${index}`} className="table-light">
                          <td>{formatReportDate(report.start_date)}</td>
                          <td></td>
                          <td></td>
                          <td>{row.particulars || ''}</td>
                          <td></td>
                          <td className="report-amount">{reportNumberFormat(row.dr_amount)}</td>
                          <td className="report-amount">{reportNumberFormat(row.cr_amount)}</td>
                          <td className="report-amount">{reportNumberFormat(row.outstanding)}</td>
                        </tr>
                      ))}
                      {(report.rows || []).map((row, index) => (
                        <tr key={`row-${index}`}>
                          <td>{formatReportDate(row.ac_date)}</td>
                          <td>{row.invoice_no || ''}</td>
                          <td>{row.product || ''}</td>
                          <td>{row.particulars || ''}</td>
                          <td>{row.description || ''}</td>
                          <td className="report-amount">{reportNumberFormat(row.dr_amount)}</td>
                          <td className="report-amount">{reportNumberFormat(row.cr_amount)}</td>
                          <td className="report-amount">{reportNumberFormat(row.outstanding)}</td>
                        </tr>
                      ))}
                      <tr className="fw-bold">
                        <td colSpan="5">Total / Closing balance</td>
                        <td className="report-amount">{reportNumberFormat(report.total_dr)}</td>
                        <td className="report-amount">{reportNumberFormat(report.total_cr)}</td>
                        <td className="report-amount">{reportNumberFormat(report.closing_balance)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              )}

              {!report && !loading && meta.dealer_name ? (
                <p className="text-muted">Dealer: {meta.dealer_name}</p>
              ) : null}
            </OtherReportResultsZone>
          </OtherReportShell>
        </div>
      </div>
    </div>
  );
};

export default DealerStatementReport;
